import { render, staticRenderFns } from "./MCQPopup.vue?vue&type=template&id=43d420f2&scoped=true"
import script from "./MCQPopup.vue?vue&type=script&lang=js"
export * from "./MCQPopup.vue?vue&type=script&lang=js"
import style0 from "./MCQPopup.vue?vue&type=style&index=0&id=43d420f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d420f2",
  null
  
)

export default component.exports